import React from 'react';
import styles from './ResumeTemplateLoraineHudson.module.css';

const ResumeTemplateLoraineHudson = () => {
  // Static data matching the image
  const data = {
    personalInfo: {
      name: 'Loraine Hudson',
      jobTitle: 'Bank Teller',
      profilePicture: 'https://images.ctfassets.net/pdf29us7flmy/4b1QvQ9kQwQwQwQwQwQwQw/1234567890abcdef/loraine-hudson.jpg', // Replace with actual image if available
      email: 'loraine@novoresume.com',
      phone: '123 445 222',
      location: 'Philadelphia, PA',
      linkedin: 'linkedin.com/in/loraine.hudson',
      summary: `Analytical, detail-oriented professional with 8+ years of extensive experience in providing exceptional customer service, administering customer transactions, and promoting company offerings in the banking industry. Exceptionally organized and focused, demonstrating an outstanding aptitude to manage and balance a variety of financial transactions in a fast-paced environment.`
    },
    skills: [
      'Cash Drawer Balancing',
      'Cash Handling Skills',
      'Complex Problem-Solving',
      'Staff Training & Development',
      'Exceptional Customer Service',
      'Analytical & Critical Thinking'
    ],
    languages: [
      { language: 'English', proficiency: 'Native or Bilingual Proficiency' },
      { language: 'Spanish', proficiency: 'Full Professional Proficiency' },
      { language: 'French', proficiency: 'Professional Working Proficiency' }
    ],
    certificates: [
      { name: 'Certified Bank Teller (06/2013)', org: 'Bank of Pennsylvania Training Center', link: '#' },
      { name: 'Teller Specialist Certificate Program (06/2013)', org: 'Independent Community Bankers of America (ICBA)', link: '#' }
    ],
    awards: [
      { name: 'Bank Teller of the Year (2019)', org: 'Double Star National Bank' },
      { name: 'The Employee of the Month - 8 times in 4 years', org: 'Bank of Pennsylvania, Lancaster Branch' }
    ],
    interests: ['Mediation', 'Archery', 'Gardening', 'Photography'],
    workExperience: [
      {
        jobTitle: 'Bank Teller',
        company: 'Double Star National Bank',
        startDate: '08/2017',
        endDate: 'Present',
        location: 'Harrisburg, PA',
        responsibilities: [
          "Administer the balancing of the branch's vaults, Automated Teller Machines (ATMs), Teller Cash Dispensers (TCDs), and Teller Cash Recyclers (TCRs) with a daily total of more than $200K.",
          "Leverage organizational and prioritization abilities, coupled with superior attention to detail to efficiently process 20+ transactions per hour, attending to 50+ customers on a daily basis.",
          "Establish strong credibility with clients by providing accurate information to address concerns regarding their accounts and other bank products, resulting in achieving the highest rate of customer loyalty and retention.",
          "Serve as a Team Lead in the absence of the supervisor to maintain seamless bank operations and procedures."
        ]
      },
      {
        jobTitle: 'Bank Teller/Lead',
        company: 'Bank of Pennsylvania, Lancaster Branch',
        startDate: '07/2013',
        endDate: '06/2017',
        location: 'Lancaster, PA',
        responsibilities: [
          "Demonstrated leadership in implementing adequate training to team members, resulting in improved performance and customer service delivery, which increased the existing client base by more than 30%.",
          "Provided efficient support to the Assistant Manager in overseeing the day-to-day operations to ensure an efficient and productive business workflow.",
          "Maximized customer satisfaction by catering a proactive day-to-day call center assistance to address client concerns.",
          "Contributed to designing and delivering effective training programs for newly hired employees to acquaint them with the bank's policies and operational procedures."
        ]
      },
      {
        jobTitle: 'Banking & Finance Intern',
        company: 'Blue Verticals Credit Union',
        startDate: '06/2012',
        endDate: '06/2013',
        location: 'Philadelphia, PA',
        responsibilities: []
      }
    ],
    education: [
      {
        degree: 'MS. in Banking and Finance',
        institution: 'The University of Philadelphia',
        startDate: '2010',
        endDate: '2012'
      }
    ]
  };

  const { personalInfo, skills, languages, certificates, awards, interests, workExperience, education } = data;

  return (
    <div className={styles.resumeContainer}>
      {/* Left Column */}
      <div className={styles.leftColumn}>
        <div className={styles.profilePicContainer}>
          <img src={personalInfo.profilePicture} alt={personalInfo.name} className={styles.profilePic} />
        </div>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>SKILLS</h2>
          <ul className={styles.skillsList}>
            {skills.map((skill, i) => <li key={i} className={styles.skillItem}>{skill}</li>)}
          </ul>
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>LANGUAGES</h2>
          {languages.map((lang, i) => (
            <div key={i} className={styles.languageItem}>
              <p className={styles.languageName}>{lang.language}</p>
              <p className={styles.languageProficiency}>{lang.proficiency}</p>
            </div>
          ))}
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>CERTIFICATES</h2>
          {certificates.map((cert, i) => (
            <div key={i} className={styles.certificateItem}>
              <p className={styles.certificateName}>{cert.name}</p>
              <p className={styles.certificateOrg}>{cert.org}</p>
            </div>
          ))}
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>HONOR AWARDS</h2>
          {awards.map((award, i) => (
            <div key={i} className={styles.awardItem}>
              <p className={styles.awardName}>{award.name}</p>
              <p className={styles.awardOrg}>{award.org}</p>
            </div>
          ))}
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>INTERESTS</h2>
          <ul className={styles.interestsList}>
            {interests.map((interest, i) => <li key={i} className={styles.interestItem}>{interest}</li>)}
          </ul>
        </section>
      </div>
      {/* Right Column */}
      <div className={styles.rightColumn}>
        <header className={styles.header}>
          <h1 className={styles.name}>{personalInfo.name}</h1>
          <h2 className={styles.jobTitle}>{personalInfo.jobTitle}</h2>
          <p className={styles.summary}>{personalInfo.summary}</p>
          <div className={styles.contactInfo}>
            <span>{personalInfo.email}</span>
            <span>{personalInfo.location}</span>
            <span>{personalInfo.phone}</span>
            <span>{personalInfo.linkedin}</span>
          </div>
        </header>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>WORK EXPERIENCE</h2>
          {workExperience.map((job, i) => (
            <div key={i} className={styles.jobItem}>
              <div className={styles.jobHeader}>
                <span className={styles.jobTitleCompany}>{job.jobTitle}</span>
                <span className={styles.jobCompany}>{job.company}</span>
                <span className={styles.jobDates}>{job.startDate} - {job.endDate}</span>
                <span className={styles.jobLocation}>{job.location}</span>
              </div>
              <ul className={styles.responsibilitiesList}>
                {job.responsibilities.map((resp, j) => <li key={j}>{resp}</li>)}
              </ul>
            </div>
          ))}
        </section>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>EDUCATION</h2>
          {education.map((edu, i) => (
            <div key={i} className={styles.educationItem}>
              <span className={styles.degree}>{edu.degree}</span>
              <span className={styles.institution}>{edu.institution}</span>
              <span className={styles.eduDates}>{edu.startDate} - {edu.endDate}</span>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default ResumeTemplateLoraineHudson; 